import { createAction } from "redux-actions";

import { SET_PAGE_NAME, SET_PAGE_LOADING } from "./constants";

export const setPageName = createAction(SET_PAGE_NAME, name => name);
export const setPageLoading = createAction(SET_PAGE_LOADING, value => value);
